import { Meta } from "@/shared/components";
import { Platforms } from "@/admin/features/platforms";

export function PlatformsPage() {
  return (
    <>
      <Meta title="Платформы" />
      <Platforms />
    </>
  );
}
